import axios from "axios";

const useApi = (props) => {
    const api_version = () => {
        return "/v" + (props?.version ?? 2);
    };

    // eslint-disable-next-line no-undef
    const environment = process?.env?.NODE_ENV ?? "";
    const hostname = (typeof window !== "undefined") ? window?.location?.hostname ?? "" : "";

    const host = () => {
        // Localhost
        if (hostname.includes("192.168.") && environment === "development") {
            return `https://mekle-prod-01.herokuapp.com/api${api_version()}`
        }

        if (
            hostname === "localhost" ||
            environment === "development"
        ) {
            return `https://mekle-prod-01.herokuapp.com/api${api_version()}`
        }

        // Staging
        if (
            hostname === "mekle-meldsak.netlify.app"
        ) {
            return `https://mekle-prod-01.herokuapp.com/api${api_version()}`
        }

        // Production
        if (
            hostname === "meldsak.mekle.no" ||
            environment === "production"
        ) {
            return `https://mekle-prod-01.herokuapp.com/api${api_version()}`
        }

        throw new Error("Invalid location hostname");
    }

    const get = async (url, data, options = {}) => {
        let formData = convertToFormData(data);

        let headers = {};
        if (options?.authenticate) headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

        return axios({
            method: "GET",
            url: host() + safeUrl(url),
            data: formData ?? data,
            ...options,
            headers,
        });
    }

    const post = async (url, data, options = {}) => {
        let formData = convertToFormData(data);

        let headers = {};
        if (options?.authenticate) headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

        return axios({
            method: "POST",
            url: host() + safeUrl(url),
            data: formData ?? data,
            ...options,
            headers,
        });
    }

    const patch = async (url, data, options = {}) => {
        let formData = convertToFormData(data);

        let headers = {};
        if (options?.authenticate) headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

        return axios({
            method: "PATCH",
            url: host() + safeUrl(url),
            data: formData ?? data,
            ...options,
            headers,
        });
    };

    const convertToFormData = (data) => {
        let formData = null;

        Object.keys(data ?? {}).forEach(key => {
            if (typeof data[key] === "object") {
                let isFile = false;
                let fileData = [];

                if (data[key] instanceof Array) {
                    data[key].forEach((item, index) => {
                        if (item instanceof File) {
                            isFile = true;
                            if (formData === null) {
                                formData = new FormData();
                            }

                            formData.append(index, item);
                            fileData.push({
                                name: item.name,
                                size: item.size,
                                extension: item.name.split(".").pop(),
                                last_modified: item.lastModified,
                                content_type: item.type,
                            })
                        }
                    });
                }

                if (isFile) {
                    data[key] = fileData;
                }
            }
        });

        if (formData !== null) {
            Object.keys(data ?? {}).forEach(key => {
                if (typeof data[key] === "object") {
                    const json = JSON.stringify(data[key]);
                    const blob = new Blob([json], {
                        type: "application/json",
                    });
                    formData.append(key, blob);
                } else {
                    formData.append(key, data[key]);
                }
            });
        }

        return formData;
    }

    const safeUrl = (url) => {
        if (url[0] !== "/") {
            url = "/" + url;
        }
        return url;
    }

    return { host, get, post, patch };
}

export default useApi;
